import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically handle the form submission
    // For now, we'll just log the data
    console.log('Form submitted:', formData);
    // Reset form
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact">
      <div className="contact-header">
        <h1>CONTACT US</h1>
        <p>have a question? we'd love to hear from you</p>
      </div>

      <div className="contact-container">
        <form className="contact-form" onSubmit={handleSubmit} role="form" aria-label="Contact form">
          <div className="form-group">
            <label htmlFor="name">name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              aria-required="true"
              aria-label="Your name"
              aria-invalid="false"
              autoComplete="name"
              placeholder="your name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              aria-required="true"
              aria-label="Your email"
              aria-invalid="false"
              autoComplete="email"
              placeholder="your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">subject</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              aria-required="true"
              aria-label="Subject"
              aria-invalid="false"
              autoComplete="off"
              placeholder="what's this about?"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              aria-required="true"
              aria-label="Your message"
              aria-invalid="false"
              autoComplete="off"
              placeholder="your message"
              rows="6"
            />
          </div>

          <button type="submit" className="submit-button" aria-label="Send message">
            send message
          </button>
        </form>

        <div className="contact-info">
          <div className="info-item">
            <h3>EMAIL</h3>
            <p>hello@illuma3d</p>
          </div>
          <div className="info-item">
            <h3>RESPONSE TIME</h3>
            <p>we typically respond within 24 hours</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact; 